var map = {
	"./announcement/Actions": 35290,
	"./auth/Actions": 57379,
	"./common/Actions": 32964,
	"./course/Actions": 44944,
	"./document/Actions": 56512,
	"./forum/Actions": 50012,
	"./guest/Actions": 8521,
	"./home/Actions": 30464,
	"./message/Actions": 1634,
	"./newsLetter/Actions": 9118,
	"./notification/Actions": 67114,
	"./profile/Actions": 26672,
	"./promoCode/Actions": 13299,
	"./questions/Actions": 18156,
	"./quizes/Actions": 6296,
	"./reports/Actions": 55154,
	"./review/Actions": 6653,
	"./students/Actions": 17121,
	"./users/Actions": 83405,
	"./video/Actions": 62290,
	"./webinar/Actions": 90663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82537;